import t from "./_getNative.js";
import o from "./_root.js";
var e = t(o, "Set");
const m = e;
export {
  m as default
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/lodash-es@4.17.21/~/lodash-es/_Set.js
// module id = 1411
// module chunks = 41